import request from 'superagent';
import SelectedWinnersStore from '../stores/selected-winners-store';
import ContestStore from '../../../stores/contest-store';
import trackEvent from '@99designs/utils/platform/trackEvent';

export const addWinner = (context, entry, done) => {
    context.dispatch('ADD_WINNER', entry);
    const store = context.getStore(SelectedWinnersStore);

    request
        .post(store.getPersistWinnerShortlistUrl())
        .timeout(10000)
        .type('form')
        .send({ designId: entry.designId })
        .end(err => {
            if (err) {
                context.dispatch('ADD_WINNER_ERROR', entry.designId);
            } else {
                context.dispatch('ADD_WINNER_SUCCESS');
            }
            done();
        });

    trackEvent('Added entry to winners drawer', {
        stage: context.getStore(ContestStore).getStage(),
    });
};

export const removeWinner = (context, designId, done) => {
    const store = context.getStore(SelectedWinnersStore);
    const entry = store.getEntry(designId);
    context.dispatch('REMOVE_WINNER', designId);

    request
        .delete(store.getPersistWinnerShortlistUrl())
        .timeout(10000)
        .type('form')
        .send({ designId: designId })
        .end(err => {
            if (err) {
                context.dispatch('REMOVE_WINNER_ERROR', entry);
            } else {
                context.dispatch('REMOVE_WINNER_SUCCESS');
            }
            done();
        });

    trackEvent('Removed entry from winners drawer', {
        stage: context.getStore(ContestStore).getStage(),
    });
};

export const showDrawer = context => {
    context.dispatch('SHOW_DRAWER');
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/actions/select-winner.js